export const getGeneral = (): {} => {
    // let info = {};
    // info['user_agent'] = navigator.userAgent;
    // // info['screen_width'] = screen.width;
    // // info['screen_height'] = screen.height;
    // info['time_zone_offset'] = new Date().getTimezoneOffset();
    // info['language'] = navigator.language;
    // // info['languages'] = navigator.languages ? navigator.languages : null;
    // info['do_not_track'] = navigator.doNotTrack ? true : false;

    return { user_agent: navigator.userAgent, time_zone_offset: new Date().getTimezoneOffset(), do_not_track: navigator.doNotTrack !== null, language: navigator.language !== null ? navigator.language : null }
}
